const getContainerRows = (container) => {
  if (Array.isArray(container?.containerRows) && container.containerRows.length > 0) return container.containerRows;
  if (Array.isArray(container?.nestedFields) && container.nestedFields.length > 0) {
    return [{ id: `row_${container.id || 'legacy'}`, fields: container.nestedFields }];
  }
  return [];
};

export const isSignatureSigned = (value) => value && typeof value === 'object' && value.status === 'signed';

export const collectSignatureFields = (fields) => {
  const out = [];
  const walk = (list) => {
    (list || []).forEach((f) => {
      if (!f) return;
      if (f.isContainer) {
        getContainerRows(f).forEach((row) => walk(row.fields || []));
        return;
      }
      if (f.type === 'signature') out.push(f);
    });
  };
  walk(fields);
  return out;
};

export const formHasAllRequiredSignatures = (fields, formData) => {
  const sigFields = collectSignatureFields(fields);
  return sigFields.every((field) => {
    if (!field.required) return true;
    return isSignatureSigned(formData?.[field.id || field.key]);
  });
};

export const SIGNATURE_CURSIVE_CLASS = 'signature-field-cursive';

/** Matches signed SignatureField name line (Bootstrap fs-4 size + optional cursive font). */
export const getSignatureDisplayClassName = (style) =>
  style === 'typed'
    ? 'signature-field-display-name signature-field-display-name--typed'
    : `signature-field-display-name ${SIGNATURE_CURSIVE_CLASS}`;

export const getSignaturePrintNameClass = (style) => getSignatureDisplayClassName(style);

export const formatSignedAt = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
};

export const normalizeFormFields = (schema) => {
  if (!schema || typeof schema !== 'object') return [];
  if (Array.isArray(schema.fields)) return schema.fields;
  return [];
};

export const createDraftSignatureValue = (existing) => {
  if (isSignatureSigned(existing)) return existing;
  const draftConsents = existing?.draftConsents && typeof existing.draftConsents === 'object' ? existing.draftConsents : {};
  return {
    status: 'unsigned',
    draftConsents,
    draftSignerName: existing?.draftSignerName || ''
  };
};
